import gql from 'graphql-tag'

export const EXPORT_TRANSACTIONS = gql`
    mutation mutationApiCall($input: TransactionsExportInput!) {
        transactionsExport(input: $input)
    }
`
